<template>
  <div style="display: inline-block;margin: 10px; user-select: none;">
    <!-- :style="[{color: `${ color }`}]" -->

    <template v-if="types == '1'">
      <div class="down" :class="[boo ? 'avcitets' : 'avcites']" :style="[
          { width: `${width}` },
          { height: `${height}` },
          { color: `${color}` },
          { fontSize: `${fontSize}` },
          { backgroundColor: `${backgroundColor}` },
          { fontSize: `${fontSize}` },
        ]" @click="btnclick" v-click-outside="clickOutSide" v-if="datalist.length != 0">
        {{ text }}
        <img class="downimg" src="../assets/icon/down.png" style="width: 15px;height: 15px;vertical-align: middle;margin-left: 25px; " />
      </div>
      <transition name="el-zoom-in-top">
        <div class="downs-top" v-if="boo">
          <div class="downs" :class="[{ avcitedowns: index == onchages }]" v-for="(item, index) of datalist" :key="index" @click="downs(index, item.title)">
            <div class="title">{{ item.title }}</div>
          </div>
        </div>
      </transition>
    </template>

    <template v-if="types == '2'">
      <div class="down" :class="[boo ? 'avcitets' : 'avcites']" :style="[
          { width: `${width}` },
          { height: `${height}` },
          { color: `${color}` },
          { fontSize: `${fontSize}` },
          { backgroundColor: `${backgroundColor}` },
          { fontSize: `${fontSize}` },
        ]" @click="btnclick" v-click-outside="clickOutSide" v-if="datalist.length != 0">
        {{ title }}
        <img class="downimg" src="../assets/icon/upleft.png" style="width: 15px;height: 15px;vertical-align: middle;margin-left: 10px; " />
      </div>
      <!-- <collapse-transition> -->
      <transition name="el-zoom-in-top">
        <div class="downs-top" v-show="boo" :style=" { fontSize: `${fontSizeDowns}` }">
          <div  v-for="(item, index) of datalist" :key="index" >
            <div class="downs" v-if="item.flag" :class="[{ 'avcitedowns': index == onchages }]" @click="downs(index, item.title , '' , item.type)">
              <div class="title">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </transition>
      <!-- </collapse-transition> -->
    </template>

    <template v-if="types == '3'">
      <div class="down" :class="[boo ? 'avcitets' : 'avcites']" :style="[
          { width: `${width}` },
          { height: `${height}` },
          { color: `${color}` },
          { fontSize: `${fontSize}` },
          { backgroundColor: `${backgroundColor}` },
          { fontSize: `${fontSize}` },
        ]" @click="btnclick" v-click-outside="clickOutSide">
        <img :src="src" style="width: 16px;height: 16px;vertical-align: middle;" alt="" />
        {{ titles }}
        <img class="downimg" src="../assets/icon/upleft.png" style="width: 15px;height: 15px;vertical-align: middle;margin-left: 10px; " />
      </div>
      <transition name="el-zoom-in-top">
        <div class="downs-top" v-if="boo">
          <div :style="[{ color: `${item.colors}` }]" class="downstreth" :class="[{ avcitedowns : index == onchages }]" v-for="(item, index) of datalist" :key="index" @click="downs(index, item.title)">
            <div class="title">{{ item.title }}</div>
          </div>
        </div>
      </transition>
    </template>

    <template v-if="types == '4'">
      <div class="down4" :class="[boo ? 'avcitets' : 'avcites']" :style="[
          { width: `${width}` },
          { height: `${height}` },
          { color: `${color}` },
          { fontSize: `${fontSize}` },
          { backgroundColor: `${backgroundColor}` },
          { fontSize: `${fontSize}` },
        ]" @click="btnclick" v-click-outside="clickOutSide">
        <img :src="ImgSrc" alt="" style="width: 16px;height: 16px;vertical-align: middle;margin-right: 5px;">
        {{ text }}
        <img class="downimg" src="../assets/icon/upleft.png" style="width: 16px;height: 16px;vertical-align: middle;margin-left: 10px; " />
      </div>
      <!-- <collapse-transition> -->
      <transition name="el-zoom-in-top">
        <div class="downs-top4" v-if="boo">
          <div class="downstreth4" :class="[{ avcitedowns4 : index == onchages }]" v-for="(item, index) of datalist" :key="index" @click="downs(index, item.title , item.src)">
            <div class="title" v-if="item.flag" @mouseenter="changeImageSrc(index , 'hover')" @mouseleave="changeImageSrc(index , '')">
              <img :src="item.srcFlag" alt="" style=" width: 16px;height: 16px;vertical-align: middle;margin-right: 5px;margin-left: -5px;" v-if="index == onchages">
              <img :src="item.src" alt="" style=" width: 16px;height: 16px;vertical-align: middle;margin-right: 5px;margin-left: -5px;" v-else>
              {{ item.title }}
            </div>
          </div>
        </div>
      </transition>
      <!-- </collapse-transition> -->
    </template>

    <template v-if="types == '5'">
      <div class="down" :class="[boo ? 'avcitets' : 'avcites']" :style="[
          { width: `${width}` },
          { height: `${height}` },
          { color: `${color}` },
          { fontSize: `${fontSize}` },
          { backgroundColor: `${backgroundColor}` },
          { fontSize: `${fontSize}` },
        ]" @click="btnclick" >
        <img :src="src" style="width: 16px;height: 16px;vertical-align: middle;" alt="" />
        {{ titles }}
        <img class="downimg" src="../assets/icon/upleft.png" style="width: 15px;height: 15px;vertical-align: middle;margin-left: 10px; " />
      </div>
      <transition name="el-zoom-in-top">
        <div class="downs-top" v-if="boo">
          <!-- <div :style="[{ color: `${item.colors}` }]" class="downstreth" :class="[{ avcitedowns : index == onchages }]" v-for="(item, index) of datalist" :key="index" @click.stop="downs(index, item.title)"> -->
          <!-- {{ item.title }} -->
          <div v-for="(item, index) of datalist" :key="index">
            <CommonbtnUpLoad v-if="item.type == 'files'" style="" class="downsUpload" :class="[{ avcitedowns : index == onchages }]"
             :uploadType="2" backgroundColor="transparent" types="multiple" :title="item.title"
             fontSize="14px" @getFiles="UploadTopDown($event,item.methodName,index)" :src="item.src">
            </CommonbtnUpLoad>
            <CommonbtnUpLoad v-if="item.type == 'file'" style="" class="downsUpload"
             :class="[{ avcitedowns : index == onchages }]" :uploadType="2" backgroundColor="transparent" types="fileImg" 
             :title="item.title" fontSize="14px" @getFile="UploadTopDown($event,item.methodName,index)" :src="item.src">
            </CommonbtnUpLoad>
          </div>
          <!-- >{{ item.title }} -->
          <!-- </div> -->
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import CollapseTransition from "../common/transition";
import CommonbtnUpLoad from '../components/common-upload.vue'
export default {
  components: {
    "collapse-transition": CollapseTransition,
    CommonbtnUpLoad
  },
  props: {
    //字体颜色
    color: {
      type: String,
      default: "#000",
    },
    // 下拉框的宽度
    width: {
      type: String,
      default: "100%",
    },
    // 下拉框的高度
    height: {
      type: String,
      default: "32px",
    },
    // 下拉框的文本
    title: {
      type: String,
      default: "",
    },
    // 字体大小
    fontSize: {
      type: String,
      default: "12px",
    },
    // 下拉字体大小
    fontSizeDowns: {
      type: String,
      default: "2px",
    },

    // 背景颜色
    backgroundColor: {
      type: String,
      default: "#E6E6E6",
    },
    // icon的地址
    src: {
      type: String,
      default: "",
    },
    // 下拉数据
    datalist: {
      type: Array,
      default: Array,
    },
    // 类型
    types: {
      type: String,
      default: "1",
    },
    titles: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      boo: false,
      srcFlagStatus: false,
      onchages: -1,
      text: "",
      ImgSrc: ""
    };
  },
  created() { },
  mounted() {
    this.text = this.datalist[0].title;
    this.ImgSrc = this.datalist[0].src;
  },
  methods: {
    UploadTopDown(e, mountedName, index) {
      let obj = {
        file: e,
        mountedName: mountedName,
        index: index
      }

      this.boo = false;
      this.$emit('UploadTopDown', obj)

    },
    changeImageSrc(index, way) {
      if (way == 'hover') {
        if (index !== this.onchages) {
          this.onchages = index;
        }
      }
      //  if (way == '') {
      //   if(index == this.onchages) {
      //     this.onchages = -1;
      //   }
      //   return
      // }
    },
    btnclick() {
      this.boo = !this.boo;
    },
    clickOutSide(){
      this.boo = false
    },
    // getFile(e) {
    //   const inputFile = e.target.files[0];
    //   this.$emit('getFile', inputFile)
      

    //   // input[file]标签防重复问题
    //   e.target.value = ""
    // },
    // getFiles(e) {
    //   const inputFile = e.target.files;
    //   this.$emit('getFiles', inputFile)
    //   console.log(inputFile, 'inputFile');
    //   // input[file]标签防重复问题
    //   e.target.value = ""
    // },
    downs(index, title, src, type) {
      if (index !== this.onchages) {
        this.onchages = index;
      }
      this.text = title;
      if (src) {
        this.ImgSrc = src
      }
      this.boo = false;

      this.$emit("downs", index);
    },
  },
};
</script>

<style scoped lang="less">
.avcite {
  .downimg {
    transform: rotate(180deg);
    transition: all 0.5s;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}
.fade-enter {
  transition: all 0.3s;
}
.fade-enter-to {
  transition: all 0.3s;
}
.fade-leave {
  transition: all 0.3s;
}
.fade-leave-to {
  transition: all 0.3s;
}
.avcites {
  border: 1px solid #e6e6e6;
  color: #e71d43;
  .downimg {
    transform: rotate(180deg);
    transition: all 0.3s;
  }
}

.avcitets {
  border: 1px solid #e6e6e6;

  .downimg {
    transform: rotate(0deg);
    transition: all 0.3s;
  }
}

.down {
  text-align: center;
  line-height: 32px;
  border-radius: 2px;
  // box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  padding-left: 5px;
  padding-right: 5px;
  cursor: pointer;
  //   animation: hides 0.8s ease-in;
}
.down4 {
  text-align: center;
  line-height: 32px;
  border-radius: 2px;
  // box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  padding-left: 10px;
  padding-right: 10px;
  margin-right: -10px;
  cursor: pointer;
  //   animation: hides 0.8s ease-in;
}
.downs-top::before {
  content: "";
  position: absolute;
  top: -4px;
  left: 30px;
  border-left: 8px solid rgb(255 255 255);
  border-top: 8px solid rgb(255 255 255);
  border-bottom: 4px solid transparent;
  border-right: 4px solid transparent;
  box-shadow: 0 -19px 24px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  transform: rotate(45deg);
}
.downs-top {
  position: absolute;
  border-radius: 2px;
  z-index: 999;
  // width: 170px;
  margin-top: 10px;
  z-index: 999;
  background-color: rgb(255 255 255);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  font-size: 14px;
  //   animation: shows 0.8s ease-in;
}

.downs-top4 {
  position: absolute;
  border-radius: 2px;
  z-index: 999;
  width: 155px;
  margin-top: 0px;
  margin-left: 1px;
  z-index: 999;
  background-color: rgb(255 255 255);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  border-radius: 2px;
  font-size: 14px;
  //   animation: shows 0.8s ease-in;
}
.downs-tops {
  position: absolute;
  border-radius: 2px;
  z-index: 999;
  width: 170px;
  margin-top: 10px;
  z-index: 999;
  background-color: #ffffff;
  font-size: 14px;
  //   animation: hides 0.8s ease-in;
}
.downs {
  // width: 170px;
  margin-top: 10px;
  z-index: 999;
  background-color: #ffffff;
  font-size: 13px;
  //   animation: shows 0.8s ease-in;
  .title {
    // width: 88%;
    height: 35px;
    // background-color: #ffe5ec;
    line-height: 35px;
    padding-left: 20px;
    padding-right: 20px;
    color: #000;
    cursor: pointer;
  }
  .title:hover {
    transition: all .3s;
    background-color: #ffe5ec;
    color: #e71d43;
  }
}
.downstreth4 {
  width: 170px;
  // margin-top: 10px;
  z-index: 999;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  //   animation: shows 0.8s ease-in;
  .title {
    width: 88%;
    height: 40px;
    // background-color: #ffe5ec;
    display: inline-block;
    line-height: 40px;
    padding-left: 20px;
    cursor: pointer;
  }
  .title:hover {
    color: #00266d;
    // background-color: rgba(219, 222, 243, 0.822);
  }
}

.downstreth {
  width: 170px;
  margin-top: 10px;
  z-index: 999;
  background-color: #ffffff;
  font-size: 14px;
  //   animation: shows 0.8s ease-in;
  .title {
    width: 88%;
    height: 44px;
    // background-color: #ffe5ec;
    line-height: 44px;
    padding-left: 20px;
    cursor: pointer;
  }
}
.avcitedowns {
  .title {
    background-color: #ffe5ec;
    color: #e71d43;
  }
  img {
    background-image: #00266d;
  }
}
.avcitedowns4 {
  .title {
    color: #00266d;
  }
}
.downsUpload {
  width: 160px;
  margin: 5px 0px 0px 0px !important;
  display: block !important;
  border-bottom: 1px solid #ffe5ec;
  text-indent: 10px;
}
.downsUpload:hover {
  transition: all .5s;
  background-color: #f1b7b78f;
}
@keyframes shows {
  0% {
    height: 0px;
  }
  100% {
    height: 50px;
  }
}
@keyframes hides {
  0% {
    height: 50px;
  }
  100% {
    height: 0px;
  }
}
</style>
